<template>
    <div>
        <label>Orsak</label><br>
        <div v-for="option in options" :key="option.handle" style="margin-bottom:4px;">
            <label style="font-weight:normal; cursor:pointer;">
                <input type="radio" :value="option.handle" v-model="localData.option_handle" @change="emit()" /> {{ option.label }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) },
        clinic: { required: true },
        options: { type: Array, default: () => [] },
    },

    data () {
        return {
            localData: { option_handle: null, ...this.value }
        }
    },

    methods: {
        emit () {
            this.$emit('input', { ...this.localData })
        }
    }
}
</script>
